import React, { Component } from 'react'
import { Button, Form, Select, message, Spin, DatePicker } from 'antd'
import NumberFormat from 'react-number-format'
import {connect} from 'dva'
import { all, create, get } from '../../services/restApi'
import PropTypes from 'prop-types'
import moment from 'moment'
import 'moment/locale/es';
import { Link } from 'dva/router'
import config from '../../utils/config'
import { getTotal, createPassword } from '../../utils'
import Currency from 'react-currency-formatter';
import DragSortableList from 'react-drag-sortable';
const _ = require('underscore')
var Icon = require('react-fontawesome');
moment.locale('es');

const FormItem = Form.Item;
const Option = Select.Option;
const MonthPicker = DatePicker.MonthPicker;

class Total extends Component {

    constructor (props) {
        super(props);

        this.state = {
            loading: false,
            hotels: [],
            filterByHotel: '',
            incomes: [],
            dataTable: []
        }

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId)  {
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};
        } else {
            if (this.props.location.pathname === '/incomes/totals')
                window.history.back()
        }

        /*if (localStorage.getItem('hotelConta')) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('hotelConta'))};*/

        message.config({top: 110, duration: 4});
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        // Query
        let query = {};
        if (this.state.currentHotel)
            query.objectId = this.state.currentHotel.objectId

        // Consulta los hoteles
        all('Hotel', {where: query, limit: 20}).then((resp) => {
            if (this.state.currentHotel) {
                this.props.form.setFieldsValue({hotel: {key: resp.results[0].objectId, label: resp.results[0].name}});
                this.setState({ hotel_selected: resp.results[0] });
            }

            this.setState({ hotels: resp.results });
        })

        this.search();
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetchHotel (value, callback) {
        setTimeout(() => {
            all('Hotel', {where: {name: {$regex: '(?i)' + value}}}).then((d) => {
                const results = d.results;
                callback(results);
            });
        }, 500);
    }


    /**
    * Validator: Checa que se haya elegido un hotel de la lista
    */
    checkHotel (rule, value, callback) {
        if (value && !value.label) {
            callback('Por favor, elija el hotel al que pertenece el cliente!');
        } else if (value) {
            let hotelSelected = _.find(this.state.hotels, {objectId: value.key});
            this.setState({ hotel_selected: hotelSelected, incomes: [], total: 0 });

            callback();
        } else {
            callback();
        }
    }


    /**
    * Imprime el reporte
    */
    print_report () {
        window.print();
    }


    /**
    * Crea el array de la lista de movimientos del reporte
    */
    addItem (destiny, item, children) {
        this.state.incomes[destiny].push({
            item: item,
            content: (
                <div>
                    <div key={item.objectId} className="row">
                        <div className="col-md-12 col-print-12 activity-grid" style={{padding: '10px 15px', cursor: 'move'}}>
                            <div className="col-md-3 col-print-3" style={{paddingLeft: 30}}>
                                {item.name ? item.name : ''}
                            </div>

                            <div className="col-md-3 col-print-3 text-center">
                                {item.amount_expense_total ? <Currency quantity={item.amount_expense_total} currency="USD" /> : ''}
                            </div>

                            <div className="col-md-3 col-print-3 text-center">
                                {item.amount_income_total ? <Currency quantity={item.amount_income_total} currency="USD" /> : ''}
                            </div>

                            <div className="col-md-3 col-print-3 text-center">
                                {item.total ? <Currency quantity={item.total} currency="USD" /> : ''}
                            </div>
                        </div>
                    </div>

                    <DragSortableList items={children || []} dropBackTransitionDuration={0.2} type="vertical"/>
                </div>
            )
        });
    }


    /**
    * Agrupamos: Cada ingreso respecto al tipo de gasto (movimiento), tipo de pago, comisión o por nómina
    */
    groupByType (array, type) {

        if (array.length > 0) {

            // Agrupaciones
            let incomesGrouped;
            if (type === 'cash_funds' || type === 'others') {
                incomesGrouped = _.groupBy(array, (r) => { return r.expense && r.expense.parent_category && r.expense.parent_category.name });

                // Las categorías principales se agrupan por separado y se incluyen al objeto de arrays
                if (incomesGrouped['undefined'] && incomesGrouped['undefined'].length > 0) {
                    let parent_categories = _.groupBy(incomesGrouped['undefined'], (r) => { return r.expense && r.expense.name });
                    _.extend(incomesGrouped, parent_categories);
                    incomesGrouped = _.omit(incomesGrouped, ['undefined']);
                }
            }

            if (type === 'payments') {
                // Agrupamos los registros que posean parent_category, es decir, las categorías secundarias
                incomesGrouped = _.groupBy(array, (r) => { return r.payment && r.payment.parent_category && r.payment.parent_category.name });

                // Lo registros que posean undefined significa que no tienen el valor parent_category, es decir, son categorías principales
                if (incomesGrouped['undefined'] && incomesGrouped['undefined'].length > 0) {
                    let parent_categories = _.groupBy(incomesGrouped['undefined'], (r) => { return r.payment && r.payment.name });
                    _.extend(incomesGrouped, parent_categories);
                    incomesGrouped = _.omit(incomesGrouped, ['undefined']);
                }
            }


            // Mapeo de los elementos
            Object.keys(incomesGrouped).map((key, index) => {

                // Model
                let item = {};
                item.objectId = incomesGrouped[key][0].objectId
                item.requestedAt = incomesGrouped[key][0].requestedAt;
                item.children = incomesGrouped[key];
                item.children.map((child, key) => { 
                    if (child.adjustment && child.adjustment > 0) {
                        child.calc_income = child.amount_income * child.adjustment; 
                        child.calc_expense = child.amount_expense * child.adjustment; 
                    } else {
                        child.calc_income = child.amount_income; 
                        child.calc_expense = child.amount_expense; 
                    }
                });
                item.amount_income_total = getTotal(incomesGrouped[key], 'calc_income');
                item.amount_expense_total = getTotal(incomesGrouped[key], 'calc_expense');
                item.total = item.amount_income_total - item.amount_expense_total;

                if ((type === 'cash_funds' || type === 'others') && key !== 'undefined') {
                    item.name = key;
                } else {
                    incomesGrouped[key][0].expense ? item.name = incomesGrouped[key][0].expense.name : item.name = key;
                }
                
                if (type === 'payments' && key !== 'undefined') {
                    item.name = key;
                } else {
                    incomesGrouped[key][0].payment ? item.name = incomesGrouped[key][0].payment.name : item.name = key;
                }


                // AGRUPACIÓN DE ITEM HIJOS
                let children = []; 
                if (type === 'cash_funds' || type === 'others') {
                    // Agrupamos los hijos
                    let childrenGrouped = _.groupBy(item.children, (r) => { 
                        return r.expense && r.expense.name;
                    })
                    if (childrenGrouped['undefined'] && childrenGrouped['undefined'].length > 0) {
                        let parent_categories = _.groupBy(childrenGrouped['undefined'], (r) => { return r.expense && r.expense.name });
                        _.extend(childrenGrouped, parent_categories);
                        childrenGrouped = _.omit(childrenGrouped, ['undefined']);
                    }

                    Object.keys(childrenGrouped).map((keyChild, indexChild) => {

                        let itemChild = {};
                        itemChild.objectId = childrenGrouped[keyChild][0].objectId
                        itemChild.requestedAt = childrenGrouped[keyChild][0].requestedAt;
                        itemChild.children = childrenGrouped[keyChild];
                        itemChild.children.map((child, key) => { 
                            if (child.adjustment && child.adjustment > 0) {
                                child.calc_income = child.amount_income * child.adjustment; 
                                child.calc_expense = child.amount_expense * child.adjustment; 
                            } else {
                                child.calc_income = child.amount_income; 
                                child.calc_expense = child.amount_expense; 
                            }
                        });
                        itemChild.amount_income_total = getTotal(childrenGrouped[keyChild], 'calc_income');
                        itemChild.amount_expense_total = getTotal(childrenGrouped[keyChild], 'calc_expense');
                        itemChild.total = itemChild.amount_income_total - itemChild.amount_expense_total;

                        if (keyChild !== 'undefined') {
                            itemChild.name = keyChild;
                        } else {
                            childrenGrouped[keyChild][0].expense ? itemChild.name = childrenGrouped[keyChild][0].expense.name : itemChild.name = keyChild;
                        }

                        // Si los movimientos fueron realizados por TRIE agregamos las subcategorías para mostrarlos en el reporte
                        if (childrenGrouped[keyChild][0].chargedTo === 'trie') {
                            children.push({
                                itemChild: itemChild,
                                content: (
                                    <div key={itemChild.objectId} className="row">
                                        <div className="col-md-12 col-print-12 activity-grid" style={{padding: '10px 15px', cursor: 'move'}}>
                                            <div className="col-md-3 col-print-3" style={{paddingLeft: 60}}>
                                                {itemChild.name ? itemChild.name : ''}
                                            </div>

                                            <div className="col-md-3 col-print-3 text-center">
                                                {itemChild.amount_expense_total ? <Currency quantity={itemChild.amount_expense_total} currency="USD" /> : ''}
                                            </div>

                                            <div className="col-md-3 col-print-3 text-center">
                                                {itemChild.amount_income_total ? <Currency quantity={itemChild.amount_income_total} currency="USD" /> : ''}
                                            </div>

                                            <div className="col-md-3 col-print-3 text-center">
                                                {itemChild.total ? <Currency quantity={itemChild.total} currency="USD" /> : ''}
                                            </div>
                                        </div>
                                    </div>
                                ) 
                            });
                        }
                    });
                }


                // Inicializamos los arrays como vacío si no existen
                if (!this.state.incomes['cash_funds'])
                    this.state.incomes['cash_funds'] = [];

                if (!this.state.incomes['payments'])
                    this.state.incomes['payments'] = [];

                if (!this.state.incomes['others'])
                    this.state.incomes['others'] = [];


                // Los gastos (cash_funds u others) que tengan activado la columna isPayment (se resta en ventas) en el tipo de movimiento
                // se cambiaran el tipo a payments para que el elemento aparezca en la columan de Ingresos
                //console.log(item.children[0].expense);
                var destiny;
                if (item.children[0] && item.children[0].expense && item.children[0].expense.isPayment) {
                    destiny = 'payments';

                } else if (item.children[0] && item.children[0].expense && item.children[0].expense.isCapital) {
                    destiny = 'others';

                } else {
                    destiny = type;
                }


                // Asignamos el elemento al array correspondiente
                this.addItem(destiny, item, children);


                // Deshabilita el spin
                if (index === Object.keys(incomesGrouped).length - 1) {
                    console.log(index);
                    console.log(Object.keys(incomesGrouped).length - 1);

                    setTimeout(() => {
                        this.props.dispatch({type: 'app/hideLoadingTable'})
                    }, 0);

                    let totalCash = getTotal(this.state.incomes['cash_funds'], (i) => { return i.item.total });
                    let totalPayment = getTotal(this.state.incomes['payments'], (i) => { return i.item.total });
                    let totalOther = getTotal(this.state.incomes['others'], (i) => { return i.item.total });
                    let totalCommissions = getTotal(this.state.incomes['commissions'], (i) => { return i.item.total });
                    let totalPayroll = getTotal(this.state.incomes['payroll'], (i) => { return i.item.total });

                    // Agregamos el registro al array que corresponden a la comisión de trie
                    let commission_trie = {
                        objectId: createPassword(),
                        name: 'MONTO INVERSIÓN Y COMISIÓN TRIE',
                        amount_expense_total: totalPayment * 0.2,
                        amount_income_total: 0,
                        total: 0 - (totalPayment * 0.2)
                    };

                    let commission_direct = {
                        objectId: createPassword(),
                        name: 'COMISIÓN DIRECTA OPERACIONES TRIE',
                        amount_expense_total: totalPayment * 0.1,
                        amount_income_total: 0,
                        total: 0 - (totalPayment * 0.1)
                    };

                    if (destiny === 'payments') {
                        this.addItem(destiny, commission_trie);
                        this.addItem(destiny, commission_direct, []);
                    }

                    this.setState({ 
                        totalCash: totalCash,
                        totalPayment: totalPayment - commission_trie.amount_expense_total - commission_direct.amount_expense_total,
                        totalOther: totalOther,
                        totalCommissions: totalCommissions,
                        totalPayroll: totalPayroll
                    });

                    this.setState({
                        dataTable: [
                            {
                                content: (
                                    <div className="row">
                                        <div className="col-md-12 col-print-12 title-grid text-left" style={{padding: '10px 15px', cursor: 'move'}}>
                                            <div className="col-md-12 col-print-12 text-bold">
                                                INGRESOS COBRADOS
                                            </div>
                                        </div>

                                        <DragSortableList items={this.state.incomes['payments']} dropBackTransitionDuration={0.2} type="vertical"/>

                                        <div className="col-md-12 col-print-12 activity-grid" style={{padding: '10px 0'}}>
                                            <div className="col-md-9 col-print-9" style={{paddingLeft: 30}}>TOTAL INGRESOS</div>

                                            <div className="col-md-3 col-print-3 text-center">
                                                <Currency quantity={this.state.totalPayment ? this.state.totalPayment : 0} currency="USD" />
                                            </div>
                                        </div>
                                    </div>
                                )
                            },
                            {
                                content: (
                                    <div className="row">
                                        <div className="col-md-12 col-print-12 title-grid text-left" style={{padding: '10px 15px', cursor: 'move'}}>
                                            <div className="col-md-12 col-print-12 text-bold">
                                                EGRESOS
                                            </div>
                                        </div>

                                        <DragSortableList items={this.state.incomes['cash_funds']} dropBackTransitionDuration={0.2} type="vertical"/>

                                        <div className="col-md-12 col-print-12 activity-grid" style={{padding: '10px 0'}}>
                                            <div className="col-md-9 col-print-9" style={{paddingLeft: 30}}>TOTAL EGRESOS</div>

                                            <div className="col-md-3 col-print-3 text-center">
                                                <Currency quantity={this.state.totalCash ? this.state.totalCash + this.state.totalCommissions + this.state.totalPayroll : 0} currency="USD" />
                                            </div>
                                        </div>
                                    </div>
                                )
                            },
                            {
                                content: (
                                    <div className="row">
                                        <div className="col-md-12 col-print-12 title-grid text-left" style={{padding: '10px 15px', cursor: 'move'}}>
                                            <div className="col-md-12 col-print-12 text-bold">
                                                CAPITAL ENTREGADO A
                                            </div>
                                        </div>

                                        <DragSortableList items={this.state.incomes['others']} dropBackTransitionDuration={0.2} type="vertical"/>

                                        <div className="col-md-12 col-print-12 activity-grid" style={{padding: '10px 0'}}>
                                            <div className="col-md-9 col-print-9" style={{paddingLeft: 30}}>TOTAL</div>

                                            <div className="col-md-3 col-print-3 text-center">
                                                <Currency quantity={this.state.totalOther ? this.state.totalOther : 0} currency="USD" />
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        ]
                    });
                }
            });
        } else {
            setTimeout(() => {
                this.props.dispatch({type: 'app/hideLoadingTable'})
            }, 0);
        }
    }


    /**
    * Consulta el reporte anterior para saber el saldo
    */
    getPreviousTotal () {
        this.props.form.validateFieldsAndScroll((errors, values) => {
            // Query
            let query = {};

            if (this.state.currentHotel) {
                query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId};
            } else {
                query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: values.hotel.key};
            }

            query.requestedAt = {
                $gte: {__type: 'Date', iso: new Date(moment(values.custom_date).subtract(1, 'months').startOf('month').format()).toISOString()},
                $lte: {__type: 'Date', iso: new Date(moment(values.custom_date).subtract(1, 'months').endOf('month').format()).toISOString()},
            }

            this.props.dispatch({type: 'app/showButtonLoading'})

            all('Income', {
                where: query,
                include: 'expense,expense.parent_category,payment,payment.parent_category', 
                skip: 0, 
                limit: 1000, 
                count: 1, 
                order: '-requestedAt'
            }).then(resp => {
                this.props.dispatch({type: 'app/hideButtonLoading'})

                if (resp.results.length > 0) {

                    // Data
                    let cash_funds = _.filter(resp.results, function (r) { return r.type == 'cash_funds' && !r.expense.omit });
                    let others = _.filter(resp.results, function (r) { return r.type == 'others' && !r.expense.omit });
                    let payments = _.filter(resp.results, {type: 'payments'});

                    let incomeCash = getTotal(cash_funds, 'amount_income');
                    let incomeOther = getTotal(others, 'amount_income');
                    let incomePayment = getTotal(payments, 'amount_income');

                    let expenseCash = getTotal(cash_funds, 'amount_expense');
                    let expenseOther = getTotal(others, 'amount_expense');
                    let expensePayment = getTotal(payments, 'amount_expense');

                    //let totalIncome = incomeCash + incomePayment + incomeOther + incomeCommissions + incomePayroll;
                    //let totalExpense = expenseCash + expensePayment + expenseOther + expenseCommissions + expensePayroll;
                    let totalIncome = incomeCash + incomePayment + incomeOther;
                    let totalExpense = expenseCash + expensePayment + expenseOther;

                    this.setState({ previousTotal: totalIncome - totalExpense });
                } else {
                    this.setState({ previousTotal: 0 });
                }

            }).catch(e => {
                if (e && e.data) message.error(e.data.error);
                else message.error('Ha ocurrido un error. Intente más tarde')    
            });
        });
    }


    /**
    * Búsqueda
    */
    search (e) {
        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Query
            let query = {
                $or: [
                    {type: 'cash_funds'},
                    {type: 'payments'},
                    {type: 'others'},
                ]
            };

            if (this.state.currentHotel) {
                query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId};
            } else {
                query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: values.hotel.key};
            }

            query.requestedAt ={
                $gte: {__type: 'Date', iso: new Date(moment(values.custom_date).startOf('month').format()).toISOString()},
                $lte: {__type: 'Date', iso: new Date(moment(values.custom_date).endOf('month').format()).toISOString()},
            }


            this.setState({incomes: [], total: 0, query: query});
            this.props.dispatch({type: 'app/showButtonLoading'})

            all('Income', {
                where: query,
                include: 'expense,expense.parent_category,payment,payment.parent_category', 
                skip: 0, 
                limit: 1000, 
                count: 1, 
                order: '-requestedAt'
            }).then(resp => {

                this.props.dispatch({type: 'app/hideButtonLoading'})
                //this.getPreviousTotal();

                if (resp.results.length > 0) {

                    let cash_funds = _.filter(resp.results, function (r) { 
                        return r.type == 'cash_funds' && 
                            (r.chargedTo === 'caja' || r.chargedTo === 'trie' || !r.chargedTo) && 
                            ((r.expense && !r.expense.omit) || r.payroll || r.commission) 
                    });

                    let others = _.filter(resp.results, function (r) { 
                        return r.type == 'cash_funds' && 
                            (r.chargedTo === 'propietario') && 
                            ((r.expense && !r.expense.omit) || r.payroll || r.commission) 
                    });

                    let payments = _.filter(resp.results, function (r) { 
                        return r.type == 'payments' && r.payment && !r.payment.omit 
                    });


                    // Los egresos (cash_funds u otros) que no posean el tipo de movimiento, entonces quiere decir que son nómina
                    cash_funds.map(item => {
                        if (!item.expense && item.payroll)
                            item.expense = { name: 'NÓMINA'};
                        
                        if (!item.expense && item.commission)
                            item.expense = { name: 'EFECTIVO ENTREGADO A TRIE'};
                    });

                    others.map(item => {
                        if (!item.expense && item.payroll)
                            item.expense = { name: 'NÓMINA'};
                        
                        if (!item.expense && item.commission)
                            item.expense = { name: 'EFECTIVO ENTREGADO A TRIE'};
                    });

                    // Data
                    this.groupByType(cash_funds, 'cash_funds');
                    this.groupByType(others, 'others');
                    this.groupByType(payments, 'payments');
                    
                } else {
                    this.setState({ 
                        total: 0, 
                        dataTable: [],
                        totalCash: 0,
                        totalPayment: 0,
                        totalOther: 0,
                        totalCommissions: 0,
                        totalPayroll: 0
                    });
                }

            }).catch(e => {
                if (e && e.data) message.error(e.data.error);
                else message.error('Ha ocurrido un error. Intente más tarde')    
            });
        })
    }


    /**
    * Render del componente
    */
    render () {
        const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <h1>
                        <Link onClick={() => window.history.back() }><i className="fa fa-arrow-circle-left"></i></Link>
                        Totales
                    </h1>
                </section>

                <section className="content">
                    <div className="row">
                        <div className="col-md-4 hidden-print">
                            <Form>
                                <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                                    <div className="box-header with-border">
                                        Consulta
                                    </div>
                                
                                    <div className="box-body">
                                        <div className="row">
                                            {!this.state.currentHotel 
                                                ? <div className="col-md-12">
                                                    <FormItem label="Hotel" hasFeedback>
                                                        {this.props.form.getFieldDecorator('hotel', {
                                                            rules: [{
                                                                required: true,
                                                                message: 'Por favor, elija el hotel',
                                                            }, {
                                                                validator: this.checkHotel.bind(this)
                                                            }]
                                                        })(
                                                            <Select 
                                                                size='large'
                                                                mode="combobox"
                                                                filterOption={false}
                                                                labelInValue={true}
                                                                optionLabelProp='label'
                                                                placeholder="Elija el hotel"
                                                                >
                                                                {hotel_options}
                                                            </Select>
                                                        )}
                                                    </FormItem>
                                                </div>
                                                : ''
                                            }

                                            <div className="col-md-12">
                                                <FormItem label="Mes" hasFeedback>
                                                    {this.props.form.getFieldDecorator('custom_date', {
                                                        initialValue: moment(),
                                                        rules: [{
                                                            required: true,
                                                            message: 'Por favor, elija el mes',
                                                        }]
                                                    })(
                                                        <MonthPicker placeholder="Seleccione el mes" />
                                                    )}
                                                </FormItem>
                                            </div>

                                            {/*<div className="col-md-12">
                                                <FormItem label="Saldo anterior" hasFeedback>
                                                    {this.props.form.getFieldDecorator('previousTotal', {
                                                        rules: [{
                                                            required: true,
                                                            message: 'Por favor, ingrese un monto. Puede ser 0',
                                                        }],
                                                        initialValue: '$0.00'
                                                    })(
                                                        <NumberFormat 
                                                            thousandSeparator={true} 
                                                            prefix={'$'} 
                                                            className="ant-input ant-input-lg" />
                                                    )}
                                                </FormItem>
                                            </div>*/}
                                        </div>

                                        <div className="row text-center paddingBottom30">
                                            <Button type='primary' onClick={this.search.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
                                                Consultar
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        </div>

                        <div className="col-md-8">
                            <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                                <div className="box-header with-border hidden-print">
                                    Resumen

                                    <div className="box-tools pull-right">
                                        <Button type='primary' onClick={this.print_report.bind(this)} >
                                            <Icon name="print" /> Imprimir
                                        </Button>
                                    </div>
                                </div>
                            
                                <Spin spinning={this.props.app.buttonLoading}>
                                    <div className="box-body main-print" style={{padding: '30px'}}>
                                        <div className="row print-header" style={{borderBottom: '1px solid #f3f3f3', paddingBottom: '15px'}}>
                                            <div className="col-md-3 col-print-3">
                                                {this.state.hotel_selected && this.state.hotel_selected.picture
                                                    ? <img src={config.externalUrl + 'uploads/hotels/' + this.state.hotel_selected.picture} style={{width: 'auto', height: '70px'}} />
                                                    : ''
                                                }
                                            </div>

                                            <div className="col-md-6 col-print-6" style={{textAlign: 'center', marginTop: '20px', fontWeight: 'bold', fontSize: '16px'}}>
                                                {this.state.hotel_selected ? 'Totales ' + this.state.hotel_selected.name : ''}
                                            </div>

                                            <div className="col-md-3 col-print-3">
                                                <div style={{textAlign: 'right', marginTop: '20px', textTransform: 'capitalize'}}>
                                                    {this.props.form.getFieldValue('custom_date') 
                                                        ? moment(this.props.form.getFieldValue('custom_date')).format('MMMM YYYY')
                                                        : ''
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row" style={{marginRight: '-30px', marginLeft: '-30px'}}>
                                            <div className="col-md-12 col-print-12 title-grid">
                                                <div className="col-md-3 col-print-3">
                                                    <label>Concepto</label>
                                                </div>

                                                <div className="col-md-3 col-print-3">
                                                    <label>Egreso</label>
                                                </div>

                                                <div className="col-md-3 col-print-3">
                                                    <label>Ingreso</label>
                                                </div>

                                                <div className="col-md-3 col-print-3">
                                                    <label>Total</label>
                                                </div>
                                            </div>
                                        </div>

                                        {/*<div className="row" style={{marginRight: '-30px', marginLeft: '-30px'}}>
                                            <div className="col-md-12 col-print-12 activity-grid" style={{padding: '10px 0'}}>
                                                <div className="col-md-3 col-print-3 text-bold" style={{paddingLeft: 30}}>
                                                    SALDO ANTERIOR
                                                </div>

                                                <div className="col-md-3 col-print-3 text-center">
                                                    {this.props.form.getFieldValue('previousTotal') ? this.props.form.getFieldValue('previousTotal') : '$0.00'}
                                                </div>

                                                <div className="col-md-3 col-print-3 text-center"></div>

                                                <div className="col-md-3 col-print-3 text-center">
                                                    {this.props.form.getFieldValue('previousTotal') ? this.props.form.getFieldValue('previousTotal') : '$0.00'}
                                                </div>
                                            </div>
                                        </div>*/}

                                        <div className="row">
                                            <DragSortableList items={this.state.dataTable} dropBackTransitionDuration={0.2} type="vertical"/>

                                            <div className="row">
                                                <div className="col-md-12 col-print-12 activity-grid" style={{padding: '10px 0', fontSize: 14}}>
                                                    <div className="col-md-9 col-print-9 text-bold" style={{paddingLeft: 30}}>
                                                        TOTAL A FAVOR
                                                    </div>

                                                    <div className="col-md-3 col-print-3 text-center">
                                                        <Currency quantity={
                                                        this.state.totalCash || this.state.totalPayment || this.state.totalOther
                                                            ? this.state.totalPayment + this.state.totalCash + this.state.totalOther
                                                            : 0
                                                        } currency="USD" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </Spin>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

Total.contextTypes = {
    router: PropTypes.object.isRequired
}

export default connect(({adon, app}) => ({adon, app}))(Form.create()(Total))


// WEBPACK FOOTER //
// ./src/components/incomes/totals.js